export { default as ValentinesDayBG } from './bg.webp';
export { default as ValentinesDayText } from './valentines-day-text.webp';
export { default as ValentinesHero } from './hero.webp';
